// ═══════════════════════════════════════════════════════════════
// Roovivo — API Client
// ═══════════════════════════════════════════════════════════════
import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 15000,
});

// Attach JWT token
API.interceptors.request.use(cfg => {
  const token = localStorage.getItem('walkin_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

API.interceptors.response.use(
  r => r,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('walkin_token');
      localStorage.removeItem('walkin_admin');
    }
    return Promise.reject(err);
  }
);

// ── PROPERTIES ───────────────────────────────────────────────
export const getProperties = (params) => API.get('/properties', { params }).then(r => r.data.data);
export const getProperty   = (id)     => API.get(`/properties/${id}`).then(r => r.data.data);
export const createProperty = (data)  => API.post('/properties', data).then(r => r.data.data);
export const updateProperty = (id, d) => API.put(`/properties/${id}`, d).then(r => r.data.data);
export const deleteProperty = (id)    => API.delete(`/properties/${id}`).then(r => r.data);
export const seedProperties = ()      => API.post('/properties/seed/valletta').then(r => r.data);

// ── RESERVATIONS ─────────────────────────────────────────────
export const createPaymentIntent = (propertyId) => API.post('/reservations/payment-intent', { propertyId }).then(r => r.data);
export const createReservation   = (data)        => API.post('/reservations', data).then(r => r.data.data);
export const trackReservation    = (id)          => API.get(`/reservations/track/${id}`).then(r => r.data.data);
export const uploadDocs          = (id, formData)=> API.post(`/reservations/${id}/docs`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(r => r.data);

// ── ADMIN ────────────────────────────────────────────────────
export const adminLogin    = (email, password)  => API.post('/admin/login', { email, password }).then(r => r.data);
export const adminMe       = ()                 => API.get('/admin/me').then(r => r.data.data);
export const adminStats    = ()                 => API.get('/admin/stats').then(r => r.data.data);
export const getReservations = (params)         => API.get('/reservations', { params }).then(r => r.data.data);
export const getReservation  = (id)             => API.get(`/reservations/${id}`).then(r => r.data.data);
export const advanceStage    = (id, stage, note)=> API.put(`/reservations/${id}/stage`, { stage, note }).then(r => r.data);
export const addNote         = (id, text)       => API.post(`/reservations/${id}/notes`, { text }).then(r => r.data);
export const verifyDoc       = (id, docType)    => API.put(`/reservations/${id}/docs/${docType}/verify`).then(r => r.data);
export const setupAdmin      = (data)           => API.post('/admin/setup', data).then(r => r.data);

export default API;
